import { PropsWithChildren } from 'react';

import css from './styles.module.css';

/** The explanatory copy below the title. */
export function EmptyStateText({ children }: PropsWithChildren) {
  return <p className={css.text}>{children}</p>;
}
